export default __webpack_public_path__ + "static/media/service_f.6f0e8273.png";